import { getBasicSliceActions, getBasicListAction } from '@probatix/common/utils/service'
import { getCurrentCoreDomain } from '@probatix/common/services/services.helpers'

import { slice } from './geoLocationListService'

export const {
  customEntrypoint,
  geoLocationsListFailed,
  geoLocationsListFetching,
  geoLocationsListReset,
  geoLocationsListSuccess,
  setGeoLocations,
} = getBasicSliceActions(slice.actions)

export const list = (params: object = {}): object => getBasicListAction({
  customEntrypoint: `${getCurrentCoreDomain()}v0/checkout/locations/geodata?tenant.myProbatixActive=true`,
  onError: geoLocationsListFailed,
  onInit: geoLocationsListFetching,
  onSuccess: geoLocationsListSuccess,
  withCredentials: false,
  ...params,
})
